export default "__VITE_ASSET__DdWhrDnA__"